import { mainAxios } from "../mainAxios";
import { getDefaultHeaders, getErrorMessage } from "./mainService";

export const reenviarSmsFolio = async (redencionId) => {
  try {
    const response = await mainAxios.post(
      `/v1/redencion/${redencionId}/reenviarFolio`,
      {},
      getDefaultHeaders()
    );

    return response.data.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getResumenFoliosPorBeneficio = async (anio, mes) => {
  try {
    const response = await mainAxios.get(
      `/v1/redencion/folios-por-beneficio?anio=${anio}&mes=${mes}`,
      getDefaultHeaders()
    );

    return response.data.data.folios;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};